import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rti-act',
  templateUrl: './rti-act.component.html',
  styleUrls: ['./rti-act.component.scss']
})
export class RtiActComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
